export default [
    {
        path: '/student/home',
        name: 'studentHome',
        component: () => import('@/pages/Home/Student'),
        children:[
            {
                path: 'myCreditDetail',
                name: 'myCreditDetail',
                component: () => import('@/pages/Student/MyCreditDetail'),
                props: true,
            }
        ]
    },

    {
        path: '/student/myTask',
        name: 'myTask',
        component: () => import('@/pages/Student/MyTask'),
        children: [{
            path: 'myTaskDetail/:taskId',
            name: 'myTaskDetail',
            component: () => import('@/pages/Student/MyTaskDetail'),
            props: true,
        }, {
            path: 'myTaskDetailOffline/:taskId',
            name: 'myTaskDetailOffline',
            component: () => import('@/pages/Student/MyTaskDetailOffline'),
            props: true,
        }],
    },

    // 直播
    {
        path: '/student/live',
        name: 'liveList',
        component: () => import('@/pages/Live/LiveList'),
        children: [{
            path: 'room/:id/:password',
            name: 'liveRoom',
            component: () => import('@/pages/Live/LiveRoom'),
            props: true,
        }],
    },

    // 新直播
    {
        path: '/live/list',
        name: 'liveListNew',
        component: () => import('@pages/Live2/LiveList'),
        children: [{
            path: '/live/room/:id/:password',
            name: 'liveRoomNew',
            component: () => import('@pages/Live2/LiveRoom'),
            props: true,
        }],
    },

    {
        path: '/student/theoryPractice',
        name: 'theoryPractice',
        component: () => import('@/pages/Student/TheoryPractice'),
    },

    /**
     * imageTabs包含识图练习、走图练习和识图学习三个内容，可以单独配这一个菜单
     * 也可分别配置识图练习、走图练习和识图学习这三个菜单
     */
    {
        path: '/student/imageTabs',
        name: 'imageTabs',
        component: () => import('@/pages/Student/ImageTabs/Index'),
    }, {
        path: '/student/imgPractice',
        name: 'imgPractice',
        component: () => import('@/pages/Student/ImageTabs/ImgPractice'),
    }, {
        path: '/student/trackPractice',
        name: 'trackPractice',
        component: () => import('@/pages/Student/ImageTabs/TrackPractice'),
    }, {
        path: '/student/imgStudy',
        name: 'imgStudy',
        component: () => import('@/pages/Student/ImageTabs/ImgStudy'),
    }, {
        path: '/student/myHistory',
        name: 'myHistory',
        component: () => import('@/pages/Student/MyHistory'),
    },
    {
        path: '/student/prejobTest',
        name: 'prejobTest',
        component: () => import('@/pages/Student/PrejobTest/Index'),
        children: [{
            path: 'prejobReport',
            name: 'prejobReport',
            component: () => import('@/pages/Student/PrejobTest/Report'),
            props: true,
        }],
    },
    {
        path: '/student/myCredit',
        name: 'myCredit',
        component: () => import('@/pages/Student/MyCredit'),
    },
]
